import { render, staticRenderFns } from "./Dbp.vue?vue&type=template&id=24a397f7&"
import script from "./Dbp.vue?vue&type=script&lang=js&"
export * from "./Dbp.vue?vue&type=script&lang=js&"
import style0 from "./Dbp.vue?vue&type=style&index=0&id=24a397f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports